{
  "title": "Join CloudServer",
  "lead": "You are invited to {{organization}} as {{role}}. Choose your name and a password.",
  "email": "E-mail",
  "name": "Your name",
  "password": "Password",
  "passwordHint": "At least 12 characters.",
  "nextStep": "Next you add a passkey or an authenticator app: everyone here signs in with a second factor.",
  "submit": "Join",
  "signedIn": "You are signed in with another account. Sign out to accept this invitation.",
  "invalidTitle": "This invitation does not work",
  "invalidLead": "The link was already used, revoked or is older than 7 days. Ask an administrator for a new one.",
  "toSignIn": "Go to sign-in"
}
